export const AGENT_ERROR_CODES = {
  ACCESS_DENIED: 'access_denied',
  UPSTREAM_UNAVAILABLE: 'upstream_unavailable',
  AGENT_UNREACHABLE: 'agent_unreachable',
  REQUEST_FAILED: 'request_failed',
  STREAM_TIMEOUT: 'stream_timeout',
  EMPTY_STREAM: 'empty_stream',
  INVALID_RESPONSE: 'invalid_response',
  LOGIN_REQUIRED: 'login_required',
} as const

export type AgentErrorCode = typeof AGENT_ERROR_CODES[keyof typeof AGENT_ERROR_CODES]
